import { useState } from "react";
import { Play } from "lucide-react";

/** Responsive YouTube demo video block for the homepage.
 *  Change YOUTUBE_VIDEO_ID below to swap the demo. */
const YOUTUBE_VIDEO_ID = "hjSqAYVkbuc"; // Latest video from youtube.com/@Zuntria

export default function DemoVideoSection() {
  const [play, setPlay] = useState(false);
  const thumb = `https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/maxresdefault.jpg`;
  const src = `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&rel=0&modestbranding=1`;

  return (
    <section className="mx-auto max-w-5xl px-6 py-16 md:px-10" data-testid="demo-video-section">
      <div className="text-center">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">See it in action</p>
        <h2 className="mt-2 font-display text-2xl font-medium tracking-tight sm:text-3xl lg:text-4xl">
          See It In Action — How Zuntria Works
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-muted-foreground md:text-base">
          Watch how real users go from goal to action plan in 60 seconds.
        </p>
      </div>

      <div className="relative mt-8 aspect-video overflow-hidden rounded-2xl border border-border bg-black shadow-2xl shadow-primary/10" data-testid="demo-video-frame">
        {play ? (
          <iframe
            src={src}
            title="Zuntria demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="h-full w-full"
          />
        ) : (
          <button
            type="button"
            onClick={() => setPlay(true)}
            className="group relative block h-full w-full"
            aria-label="Play demo video"
            data-testid="demo-video-play-btn"
          >
            <img
              src={thumb}
              alt="Zuntria demo"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              onError={(e) => { e.target.src = `https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/hqdefault.jpg`; }}
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/40 transition-colors group-hover:bg-black/30">
              <div className="flex h-20 w-20 items-center justify-center rounded-full bg-accent shadow-2xl transition-transform group-hover:scale-110">
                <Play className="ml-1 h-8 w-8 fill-white text-white" />
              </div>
            </div>
          </button>
        )}
      </div>
    </section>
  );
}
